// removed by extract-text-webpack-plugin
module.exports = {"root":"FieldCheckbox__root__3T2Ju","input":"FieldCheckbox__input__1YEbE","box":"FieldCheckbox__box__3Nytw","checked":"FieldCheckbox__checked__1cRXY","text":"FieldCheckbox__text__26ZNX","label":"FieldCheckbox__label__1YPQT","checkboxWrapper":"FieldCheckbox__checkboxWrapper__2kXpd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldCheckbox/FieldCheckbox.css
// module id = 1785
// module chunks = 0